export default __webpack_public_path__ + "static/media/header-onboarding-1.8d6f1fcb.svg";